import JEditable from "jqueryEditable";
import CustomTagEditable from "libs/jquery-editable/modules/custom.tag.editable";

class DatePickerEditable extends CustomTagEditable {
    element(settings, original) {
        var input = $('<input>');
        if (settings.width !== 'none') {
            input.width(settings.width);
        }
        if (settings.height !== 'none') {
            input.height(settings.height);
        }
        input.attr('autocomplete', 'off');
        input.attr('readonly', 'readonly');
        $(this).append(input);
        return (input);
    }

    plugin(settings, original) {
        settings.onblur = 'ignore';
        const $input = $(this).find('input');
        $input.datetimepicker(settings).bind('click', function () {
            $(this).datetimepicker('show');
            return false;
        });
        $input.on("remove", function () {
            $(this).datetimepicker('destroy');
            return false;
        });
    }
}

class DateTimePickerEditable extends CustomTagEditable {
    element(settings, original) {
        var input = $('<input>');
        if (settings.width !== 'none') {
            input.width(settings.width);
        }
        if (settings.height !== 'none') {
            input.height(settings.height);
        }
        input.attr('autocomplete', 'off');
        input.attr('readonly', 'readonly');
        $(this).append(input);
        return (input);
    }

    plugin(settings, original) {
        // settings. = 'ignore';
        const $input = $(this).find('input');
        $input.datetimepicker(settings).bind('click', function () {
            $(this).datetimepicker('show');
            return false;
        });
        $input.on("remove", function () {
            $(this).datetimepicker('destroy');
            return false;
        });
        DateTimePickerEditable.customButton('.xdsoft_datetimepicker', $input, settings);

    }

    static customButton(ev, picker, options) {
// show the "CLEAR" date button
        const appendTheCustomButton = (elementToAppendTo, {id, classes, label, attrType, objectId}) => {
            //add the new custom button only once
            const $button = $("<button>").attr("id", id)
                .attr("class", classes)
                .data("attr-type", attrType)
                .data("object-id", objectId)
                .text($.i18n.t(label));
            const newElement = $(elementToAppendTo).append($button);
            const button_id = $($button).attr("id");
            if (attrType)
            // if ($($(newElement).find(`#${button_id}`)).length != 0)
                $button.unbind().on("click", function (e) {
                    var objectId = $(e.currentTarget).data("object-id");
                    var attrType = $(e.currentTarget).data("attr-type");
                    picker.datetimepicker('hide');
                    $(window).trigger("datetimepicker:focusout", [attrType, objectId]);
                    $(window).trigger("datetimepicker:clearDateButtonClicked", [attrType, objectId, picker]);
                });
            else {
                $button.unbind().on("click", e => {
                    picker.datetimepicker('hide');
                    var attrType = $('.xdsoft_datetimepicker').find(".dateNullifyButton").data("attr-type");
                    var objectId = $('.xdsoft_datetimepicker').find(".dateNullifyButton").data("object-id");
                    $(window).trigger("datetimepicker:focusout", [attrType, objectId]);
                });
            }

            return newElement;
        };

        const $el = $('<div id="customButtons" style="text-align: center; display: block; clear: both;"></div>');
        //check if the buttons are already inserted in the datetimepicker, to avoid duplicates
        //search for the #closeButton, since it will appear on all datetimepickers
        if ($(ev).last().find("#closeButton").length === 0)
            options.customButton.map(b => appendTheCustomButton($el, b));
        $(ev).append($($el));
    }

}

JEditable.addInputType('datepicker', DatePickerEditable);
JEditable.addInputType('datetimepicker', DateTimePickerEditable);

export {DatePickerEditable, DateTimePickerEditable};